module.exports = __webpack_public_path__ + "img/icon-twitter.8bb57aba.svg";